
import { GridWidgetService } from '../grid-widget.services';
import { SystemService } from 'common/services/core-services/system.service';
import { GridParams } from 'common/models/utility-models/list-utility.model';
import { DataModel, MetaModel, WidgetModel } from 'common/models/utility-models/base-model';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

import { AssignmentGridDataService } from 'common/services/data-services/admin/assignment/assignment-grid-data.service';
import { API_URL, ASSIGNMENT_GRID_URL, ROUTE_PATH } from 'common/constants/sm-constants';
import { SmMetaModel } from 'common/models/utility-models/meta-model';
import { InvitedModel } from 'common/models/page-models/Invited Students Model/invited-grid-data.model';
import { InvitedGridMetaModel } from 'common/models/page-models/Invited Students Model/invited-grid-meta.model';
import { InvitedListingModel } from 'common/models/page-models/Invited Students Model/invited-grid-params.model';
import { InvitedGridDataService } from 'common/services/data-services/admin/invited/invited-grid-data.service';


@Injectable({
    providedIn: 'root'
})
export class InvitedGridWidgetService extends GridWidgetService<InvitedModel, InvitedListingModel> {
    constructor(protected override ds: InvitedGridDataService, protected systemService: SystemService) {
        super(ds);
    }

    createQueryParams(queryParam): GridParams {
        for (const key in queryParam) {
            this.queryparm[key] = queryParam[key];
        }
        return this.queryparm;
    }

   
    getMetaModel(): MetaModel {
        const meta = new InvitedGridMetaModel().getMetaModel();
        return meta;
    }

    override  prepareMetaModel(dataModel: DataModel, metaModel: SmMetaModel, routeData: WidgetModel): Promise<SmMetaModel> {
        return new Promise<SmMetaModel>((resolve, reject) => {
          metaModel
          resolve(metaModel);
        });
      }

   

}

